// extracted by mini-css-extract-plugin
export var button = "reciteMe-module--button--540ad";
export var icon = "reciteMe-module--icon--26a52";